/* global google */

/* Arguments JSON : 
            "typeMap" sert à gérer le visuel de la map. Valeurs STRING possibles : "terrain", "hybrid", "satellite","roadmap"
            "isTrafficEnabled" sert à activer la vision du traffic. Valeurs BOOLEAN possibles: true, false
            "optionOpenInGoogleMapActivated" sert à afficher le texte "Ouvrir dans Google map" dans le infoText du marker. Valeurs BOOLEAN possibles: true, false
            "displayMyLocationButton" sert à afficher le bouton permettant de se géolocaliser. Valeurs BOOLEAN possibles: true, false
            "displayWorkerLocationButton" sert à afficher le bouton permettant de géolocaliser l'intervenant. À associer avec l'ActionEvents "getWorkerCoords". Valeurs BOOLEAN possibles: true, false
            "displayStreetViewButton" sert à afficher le bouton permettant d'utiliser streetView. Valeurs BOOLEAN possibles: true, false
            "displayFullscreenButton" sert à afficher le bouton permettant de mettre l'affichage en fullscreen. Valeurs BOOLEAN possibles: true, false
            "displayChangeButton" sert à afficher le bouton permettant de changer de plan entre satellite et roadmap avec options permettant de choisir d'activer le relief (terrain) pour la roadmap et le nom des rues, les villes, etc...(hybrid) pour satellite. Valeurs BOOLEAN possibles: true, false
            "baseLocation" permet d'ajouter un marqueur sur la map qui sera automatiquement centré dessus. À ne pas associer avec "addressList". Valeur possible : une address sous format Json Stringigy
            "addressList" permet d'ajouter plusieurs marqueurs sur la map et se centrer sur le dernier point. À ne pas associer avec "baseLocation". 
           
   ActionEvents :
            "getWorkerCoords" sert à récupérer les coordonnées de l'intervenant. À associer avec "displayWorkerLocationButton".
            
   Infos Complémentaires :
            Pour ajouter une nouvelle addresse vous pouvez utiliser addPoints([]) ne prend qu'un tableau d'Address en entrée.
   */





import { useState, useEffect, useRef } from "react";
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";

import { APIProvider, Map, useMapsLibrary, useMap, ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import Swal from "sweetalert2";
import * as commonFunc from 'scripts/common';

import {
    Label, Col, Progress
} from "reactstrap";

const mapsAPI_KEY = "AIzaSyCXONdJ6W5hndXH0ivRXCR3MbUMO4JXHdw";
const customMap = "acf35472d6f229b5a77f7ced"; // changer pour une map perso (Provoque un problème quand changement en satellite)


export default function GmapsFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue } = formManager;


    const args = data.argumentsObj;
    const baseLocation = (args.baseLocation) ? args.baseLocation : null;
    const addressList = (args.addressList) ? args.addressList : null;
    var srcAddresses = [];
    if (baseLocation) srcAddresses = [baseLocation];
    else if (addressList) srcAddresses = addressList;

    // Hooks React :
    const mapInstance = useRef(null);
    const [tabAddress, setTabAddress] = useState(srcAddresses);
    const [isMapReady, setIsMapReady] = useState(false);

    const [shouldRender, setShouldRender] = useState(false);


    // Constantes internes :


    const center = { lat: 47.109999, lng: 2.360567 };
    //const optionOpenInGoogleMapActivated = (args.optionOpenInGoogleMapActivated) ? args.optionOpenInGoogleMapActivated : null;
    const showMapTypeButton = (args.displayChangeButton) ? args.displayChangeButton : false;
    const showStreetViewButton = (args.displayStreetViewButton) ? args.displayStreetViewButton : false;
    const showFullscreenButton = (args.displayFullscreenButton) ? args.displayFullscreenButton : false;
    const showMyLocationButton = (args.displayMyLocationButton) ? args.displayMyLocationButton : false;
    const showWorkerLocationButton = (args.displayWorkerLocationButton) ? args.displayWorkerLocationButton : false;
    const markerOptions = {
        isMarkerDraggable: (args.markerDraggable) ? args.markerDraggable : false,
        optionOpenInGoogleMapActivated: (args.optionOpenInGoogleMapActivated) ? args.optionOpenInGoogleMapActivated : null,
        markerDragExternAction: props.changeGeoAddress,
    }

    useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    // Fonctions :
    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.addPoints = (newAddressList) => {
        /*const addressType = newAddressList[0].type;
        let indexAddressToRemove = -1;
        switch (addressType) {
            case "Preview":
                indexAddressToRemove = tabAddress.findIndex(address => address.type === "Preview");
                break;
            case "Intervenant":
                indexAddressToRemove = tabAddress.findIndex(address => address.type === "Intervenant");
                break;
            default:
                break;
        }
        if (indexAddressToRemove !== -1) tabAddress.splice(indexAddressToRemove, 1);*/
        setTabAddress((prev) => [...prev, ...newAddressList])
    }

    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));
    if (disabled) {
        data.functionManager.setPreviewMarkerDraggable(false);
    }


    var frameClass = "d-inline-block mb-3";
    var frameStyle = { minWidth: "100px" };
    var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";
    //TODO : design
    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_gmaps");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            //titleClass += modelFctManager.convertWidthToGrid(100);
        }
    }

    //gestureHandling = none >> map fixe
    //gestureHandling = greedy >> map accessible
    //gestureHandling = auto >> entre cooperativer et greedy en fonction de la page
    return (<Col data-name="GmapsFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign?.design?.spacing ? "" : "p-0"}`} style={frameStyle}>
            <div className="justify-content-center text-center">
                <APIProvider region="FR" apiKey={mapsAPI_KEY} libraries={['marker']}>
                    <Map
                        mapId={customMap} //TODO
                        style={{ width: '100%', height: '50vh', margin: '0 auto', }}
                        mapTypeId={args.typeMap}
                        defaultCenter={center}
                        defaultZoom={11}
                        region={"FR"}
                        options={{
                            disableDefaultUI: true,
                            zoomControl: true,
                            mapTypeControl: showMapTypeButton,
                            streetViewControl: showStreetViewButton,
                            fullscreenControl: showFullscreenButton,
                            clickableIcons: false,
                        }}
                        gestureHandling={'cooperative'}
                        onIdle={(event) => {
                            mapInstance.current = event.map
                            setIsMapReady(true);
                        }}
                        {...args?.mapOptions}
                    >
                        <MyLocationButton isMyLocationButtonEnabled={showMyLocationButton} />
                    </Map>
                    <PlacementPoints tabAddress={tabAddress} isMapReady={isMapReady} functionManager={data.functionManager} markerOptions={markerOptions} />
                    <MapAdditionnalOptions args={args} />
                </APIProvider>
                {(isMapReady && showWorkerLocationButton) && <WorkerLocationButton data={data} modelFctManager={modelFctManager} />}
            </div>
        </Col>
    );
}

function PlacementPoints({ tabAddress, isMapReady, functionManager, markerOptions }) {

    // Hooks React:
    const geocodingApiReload = useMapsLibrary("geocoding")
    const [geocodingService, setGeocodingService] = useState(null);
    const infoWindow = useRef(null);
    const previewMarker = useRef(null);
    const workerMarker = useRef(null);
    const lastTabAddressRef = useRef(null);

    // Constantes Internes :
    const map = useMap();

    functionManager.setPreviewMarkerDraggable = (isDraggable) => {
        if (!previewMarker.current) return;
        previewMarker.current.gmpDraggable = isDraggable;
    }
    functionManager.reloadPreviewMarkerPin = () => {
        if (!previewMarker.current) return;
        previewMarker.current.content = generatePinElement({ index: null, infoWindow: infoWindow.current, infos: "Preview" })
    }
    functionManager.deletePreviewMarker = () => {
        if (!previewMarker.current) return;
        previewMarker.current.map = null;
    }

    // Effects :
    useEffect(() => {
        if (!geocodingApiReload || !tabAddress || tabAddress.length === 0 || !isMapReady) return;
        setGeocodingService(new window.google.maps.Geocoder());
    }, [geocodingApiReload, tabAddress, isMapReady])

    useEffect(() => {
        if (!geocodingService || !map) return;
        const asyncGeocodeList = [];
        tabAddress.forEach((actualAddress) => {
            if (!actualAddress.geoAddress || !actualAddress.geoAddress.geoLat || !actualAddress.geoAddress.geoLon) {
                asyncGeocodeList.push(GeocodingAddress(actualAddress, geocodingService).then((geoAddress) => {
                    if (geoAddress) {
                        actualAddress.geoAddress = geoAddress;
                    }

                }));
            }
        });
        Promise.all(asyncGeocodeList).then(() => {
            let markerWorkerExist = false;
            let markerPreviewExist = false;

            //setTimeout pour intégrité d'accès au google.maps.marker.AdvancedMarkerElement
            setTimeout(() => {
                tabAddress.forEach((actualAddress, index) => {
                    if (!lastTabAddressRef.current || !lastTabAddressRef.current[index] || lastTabAddressRef.current[index] != actualAddress) {
                        let finalIndex = (tabAddress.length === 1) ? null : index + 1
                        let marker = null;
                        if (!actualAddress.type) {
                            marker = generateMarker({ actualAddress: actualAddress, index: finalIndex, map: map, optionOpenInGoogleMapActivated: markerOptions.optionOpenInGoogleMapActivated, infoWindow: infoWindow.current, markerDraggable: false, markerDragExternAction: null });
                        }
                        else {
                            switch (actualAddress.type) {
                                case "Intervenant": {
                                    marker = workerMarker;
                                    if (marker.current) {
                                        marker.current.map = null;
                                        marker.current = null;
                                        markerWorkerExist = true;
                                    }
                                    break;
                                }
                                case "Preview": {
                                    marker = previewMarker;
                                    if (marker.current) {
                                        marker.current.map = null;
                                        marker.current = null;
                                        markerPreviewExist = true;
                                    }
                                    break;
                                }
                                default: break;
                            }
                            marker.current = generateMarker({ actualAddress: actualAddress, index: null, map: map, optionOpenInGoogleMapActivated: markerOptions.optionOpenInGoogleMapActivated, infoWindow: infoWindow.current, markerDraggable: markerOptions.isMarkerDraggable, markerDragExternAction: markerOptions.markerDragExternAction });
                        }
                        map.panTo((marker.current) ? marker.current.position : marker.position);
                    }
                })
                if (markerPreviewExist) {
                    tabAddress.splice(tabAddress.findIndex(address => address.type === "Preview"), 1)
                }
                if (markerWorkerExist) {
                    tabAddress.splice(tabAddress.findIndex(address => address.type === "Intervenant"), 1)
                }
                lastTabAddressRef.current = tabAddress;
            }, 1000);
        })
    }, [geocodingService, tabAddress, map]);

    return null;
}
function generatePinElement({ index, infos }) {

    // Constantes Internes :
    let colorBackground;
    let indexPin = (index) ? index : "";

    // Traitements :
    switch (infos.type) {
        case "Intervenant":
            colorBackground = '#1A2421';
            indexPin = "🛠️" // émoji ou string uniquement!
            break;
        case "Preview":
            if (infos.isManual) {
                colorBackground = "#03e3fc"
                break;
            }
            colorBackground = '#26457a';
            break;
        default:
            colorBackground = '#960000'
            break;
    }
    const pinElement = new google.maps.marker.PinElement({
        background: `${colorBackground}`,
        borderColor: 'white',
        glyph: String(indexPin),
        glyphColor: 'white',
        scale: 1.2,
    });

    return pinElement.element
}

function generateInfoWindow({ actualAddress, infos, optionOpenInGoogleMapActivated, type }) {
    // Constantes Internes :
    const openInGoogleMapString = (optionOpenInGoogleMapActivated) ?
        '<p><a target="_blank" rel="noopener noreferrer" href="https://www.google.com/maps/search/?api=1&query= ' + `${actualAddress.geoAddress.geoLat}, ${actualAddress.geoAddress.geoLon}` + '"> Ouvrir dans Google Map </a></p>' : ""
    const employementText = (infos?.type === "Intervenant") ? "Intervenant : " : "Client : ";
    const hasTitleString = (actualAddress.title) ?
        '<p>' + employementText + ` ${actualAddress.title}  </p>` : ""

    let contentString = "";
    switch (type) {
        case "coordsChanged": {
            contentString = '<div id="content" class="text-dark">' +
                `<p><b> ${actualAddress.addressMain}` + ((actualAddress.addressPlus) ? (", " + actualAddress.addressPlus) : "") + ` <br/> ${actualAddress.pc} ${actualAddress.city} </b ></p > Lat. : ` +
                actualAddress.geoAddress.geoLat + " Long. : " + actualAddress.geoAddress.geoLon +
            "</div>"
            break;
        }
        default: {
            contentString = '<div id="content" class="text-dark">' +
                `<p><b> ${actualAddress.addressMain}` + ((actualAddress.addressPlus) ? (", " + actualAddress.addressPlus) : "") + `<br/> ${actualAddress.pc}  ${actualAddress.city} </b></p>` +
                hasTitleString + openInGoogleMapString +
                "</div>"
        }
    }
    return new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 175
    })
}


// Problème lié au marqueur en mobile donc pas de déplacement du marqueur à la main  
function generateMarker({ actualAddress, index, map, infoWindow, optionOpenInGoogleMapActivated, markerDraggable, markerDragExternAction }) {
    // Constantes Internes :
    const isMarkerDraggable = (markerDraggable && actualAddress.type === "Preview" && !commonFunc.isMobileDevice());
    const finalLat = actualAddress.geoAddress.geoLat;
    const finalLng = actualAddress.geoAddress.geoLon;
    const infos =
    {
        type: (actualAddress.type) ? actualAddress.type : null,
        isManual: (actualAddress.geoAddress.isManual) ? true : false,
        markerDraggable: isMarkerDraggable
    };
    const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: finalLat, lng: finalLng },
        map,
        title: (markerDraggable) ? "Vous pouvez déplacer ce marqueur !" : "Voici un marqueur",
        gmpClickable: true,
        gmpDraggable: isMarkerDraggable,
        content: generatePinElement({ index: index, infos })
    });
    // Traitements :
    marker.addEventListener("gmp-click", function (e) {
        if (infoWindow) {
            infoWindow.close();
            infoWindow.map = null;
            console.log("PASSAGE")
        }
        infoWindow = generateInfoWindow({ actualAddress, infos, optionOpenInGoogleMapActivated });
        infoWindow.open({
            anchor: marker,
            map,
        })
    })
    if (isMarkerDraggable) {
        marker.addListener('drag', (event) => {
            const position = marker.position;
            if (infoWindow) infoWindow.close();
            actualAddress.geoAddress.geoLat = position.lat;
            actualAddress.geoAddress.geoLon = position.lng;
            actualAddress.geoAddress.isManual = true;
            actualAddress.geoAddress.geoSrc = "manual";
            infos.isManual = true;
            marker.content = generatePinElement({ index: index, infos })
            if (markerDragExternAction) markerDragExternAction(actualAddress.geoAddress, true)
            infoWindow = generateInfoWindow({ actualAddress, infos, optionOpenInGoogleMapActivated, type: "coordsChanged" });
            infoWindow.open(marker.map, marker);
        });
    }

    return marker;
}







function calcCenter({ addressGeocoded }) {
    // Variables Internes :
    let latFinal = 0.0
    let lngFinal = 0.0

    // Traitements :
    addressGeocoded.forEach((actualAddress) => {
        latFinal += actualAddress.geoAddress.geoLat
        lngFinal += actualAddress.geoAddress.geoLon
    });
    latFinal = latFinal / addressGeocoded.length
    lngFinal = lngFinal / addressGeocoded.length
    const result = new google.maps.LatLng(latFinal, lngFinal);

    return result
}
function MapAdditionnalOptions({ args }) {
    // Constantes Internes
    const mapApiLoaded = useMapsLibrary("maps");
    const map = useMap();
    useEffect(() => {
        if (!mapApiLoaded || !map) return;
        new google.maps.TrafficLayer().setMap((args.isTrafficEnabled) ? map : null);
    }, [mapApiLoaded, map])



    return null;
}

function MyLocationButton({ isMyLocationButtonEnabled }) { // TODO à changer si ajout d'un marker de géolocalisation natif
    // Hooks React :
    const map = useMap()
    const myLocationMarker = useRef(null);
    const myLocationButtonWrapper = useRef(null);

    // Constantes Internes :
    const customLocationButton = (<div style={{
        width: '14px',
        height: '14px',
        background: '#4285F4',
        border: '2px solid white',
        borderRadius: '50%',
        boxShadow: '0 0 6px rgba(66, 133, 244, 0.7)',
    }} />)

    // Effects :
    useEffect(() => {
        if (!isMyLocationButtonEnabled) return;
        myLocationButtonWrapper.current = document.createElement("div");
        const root = createRoot(myLocationButtonWrapper.current);
        root.render(customLocationButton)

    }, [isMyLocationButtonEnabled])


    // Fonctions :
    const centerOnMyLocation = (() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const myLocationLat = position.coords.latitude;
                    const myLocationLng = position.coords.longitude;
                    map.panTo({ lat: myLocationLat, lng: myLocationLng });
                    if (myLocationMarker.current) {
                        myLocationMarker.current.position = { lat: myLocationLat, lng: myLocationLng };
                    }
                    else {
                        myLocationMarker.current = new google.maps.marker.AdvancedMarkerElement({
                            position: { lat: myLocationLat, lng: myLocationLng },
                            map: map,
                            content: myLocationButtonWrapper.current.firstChild
                        });
                    }

                },
                (error) => {
                    let errorText = "";
                    switch (error.code) {
                        case 1: errorText = "Permission de Géolocalisation non active !"; break;
                        case 2: errorText = "Votre position n'a pas pu être détectée !"; break;
                        case 3: errorText = "Délai de recherche de position dépassé !"; break;
                        default: errorText = "Erreur Indéterminée !"
                    }
                    Swal.fire({
                        title: "Oops...",
                        icon: "error",
                        text: errorText,
                        allowOutsideClick: true,
                        allowEscapeKey: false,
                    });
                },
                { enableHighAccuracy: true }
            )
        }
        else {
            Swal.fire({
                title: "Oops...",
                icon: "error",
                text: "Géolocalisation non-supportée sur ce navigateur !",
                allowOutsideClick: true,
                allowEscapeKey: false,
            });
        }
    })

    if (!isMyLocationButtonEnabled) return null;

    return <MapControl position={ControlPosition.TOP_RIGHT}><button style=
        {{
            background: 'white',
            border: '1px solid rgba(0, 0, 0, 0.15)',
            borderRadius: '1px',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
            width: '38px',
            height: '38px',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 0,
            margin: '10px',
            outline: 'none',
            transition: 'color 0.3s ease',
            color: 'rgba(0,0,0,0.54)',
        }}
        title="Voir ma position"
        onMouseEnter={e => (e.currentTarget.style.color = 'rgba(0,0,0,0.87)')}
        onMouseLeave={e => (e.currentTarget.style.color = 'rgba(0,0,0,0.54)')}
        onClick={() => centerOnMyLocation()}
    ><i className="fa fa-crosshairs" style={{ fontSize: '20px' }} /></button></MapControl>
}
function WorkerLocationButton({ data, modelFctManager }) {

    // Fonctions :
    const centerOnWorkerLocation = (() => {
        if (data.onActionEvents && data.onActionEvents["onClick"]) {
            data.onActionEvents["onClick"].forEach((args) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: null }).then(actionResponse => {
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
    });



    return <button className="btn btn-success mt-3" type="button"
        title="Géolocaliser l'intervenant"
        onClick={() => centerOnWorkerLocation()}
    >Géolocaliser l'intervenant</button>
}

export async function GeocodingAddress(address, geocodingService) { // GeocodingService lié à useMapsLibrary("Geocoding")
    console.debug(geocodingService);

    const args = {
        address: address,
        type: "addressUnit"
    };
    const geocodingWithGoogle = async () => {
        const results = await geocodingService.geocode({ address: `${address.addressMain},${address.pc} ${address.city}, ${address.country}` });
        const loc = results.results[0].geometry.location;
        return { geoLon: loc.lng(), geoLat: loc.lat(), isManual: false, geoSrc: "geocodeGoogle" }
    }
    let resultGeoAddress = null;
    /*const response = await commonFunc.getMethod("../api/Geocode/getAddress", args);
    if (response.data) {
        if (response.data.isSuccess) {
            resultGeoAddress = response.data.result;
        }
    }*/
    if (!resultGeoAddress) resultGeoAddress = await geocodingWithGoogle();
    console.log(resultGeoAddress)
    return resultGeoAddress;
}